import { Avatar, Grid, Stack, Typography } from '@mui/material';
import { Copy, PurpleOutlineWarningIcon } from 'Images';
import { Equipment_Order_STATUSES, IPresTruncatedDataDTO } from 'API';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useDictionary } from 'Hooks';
import { format } from 'date-fns';
import { FC } from 'react';
import { OneOrTwoButtons } from 'Components/OneOrTwoButtons';
import { useNavigate } from 'react-router-dom';
import { shortDateFormat } from 'Config';
import { Status } from 'Modules/MedicineOrderInfo/Status';

interface IPrescriptionsListProps {
  item: IPresTruncatedDataDTO;
  onShowPrescriptionDetailsClick: (
    clickedPrescription: IPresTruncatedDataDTO
  ) => void;
  itemRecordStatus: string;
  titles: string[];
}

export const PrescriptionsListItemDesktop: FC<IPrescriptionsListProps> = (
  props: IPrescriptionsListProps
) => {
  const dictionary = useDictionary(
    Dictionary,
    DICTIONARY.MedicationsAndPrescriptionsLobby
  );
  const navigate = useNavigate();
  const orderID = props.item.prescCode || props.item.originalOrderId;

  const handleNavigate = () => {
    navigate(`/medicine/${orderID}`);
  };
  const createDate = props.item.createDate;
  const formattedCreateDate = createDate
    ? format(new Date(createDate), shortDateFormat)
    : '';
  const formattedUpdateDate = props.item.currentStatusDate
    ? format(new Date(props.item.currentStatusDate), shortDateFormat)
    : ' ';

  const columnStyle = {
    cursor: 'pointer',
    height: '54px',
    position: 'relative',
    top: '-2px',
  };

  return (
    <Grid
      component={'li'}
      container
      sx={{
        p: '24px',
        bgcolor: '#fff',
        alignItems: 'start',
        justifyContent: 'space-between',
        borderBottom: '1px solid #E7EDFF',
      }}
      tabIndex={0}
    >
      <Grid item sm={1.75} onClick={handleNavigate} sx={columnStyle}>
        <Typography variant='body6'>{props.titles[0]}</Typography>
        <Typography variant='body2'>
          {props.item.prescCode || dictionary.toBeDetermined}
        </Typography>
      </Grid>
      <Grid item sm={1.75} onClick={handleNavigate} sx={columnStyle}>
        <Typography variant='body6'>{props.titles[1]}</Typography>
        <Typography variant='body2'>{formattedCreateDate}</Typography>
      </Grid>
      <Grid item sm={1.5} onClick={handleNavigate} sx={columnStyle}>
        <Typography variant='body6'>{props.titles[4]}</Typography>
        <Typography variant='body2'>{props.item.itemsCount}</Typography>
      </Grid>
      <Grid item sm={1} onClick={handleNavigate} sx={columnStyle}>
        <Typography variant='body6'>{props.titles[2]}</Typography>
        <Typography variant='body2' sx={{ height: '24px' }}>
          {formattedUpdateDate}
        </Typography>
      </Grid>
      <Grid item sm={2.5} onClick={handleNavigate} sx={{ cursor: 'pointer' }}>
        <Stack sx={{ m: '0 32px' }}>
          <Typography variant='body6'>{props.titles[3]}</Typography>
          <Status
            status={props.item.currentStatus}
            statusLabel={props.item.currentStatusLabel || ''}
          />
        </Stack>
      </Grid>

      <Grid item sm={3.5}>
        <OneOrTwoButtons
          width='max-content'
          leftButton={{
            label: dictionary.moreInfo,
            onClick: handleNavigate,
            ariaLabel: `${dictionary.moreInfo} ${
              dictionary.aboutOrderFrom
            } ${format(new Date(props.item.createDate), shortDateFormat)}`,
          }}
          rightButton={
            props.item.currentStatus > Equipment_Order_STATUSES.takenCareByDept4
              ? {
                  label: dictionary.duplicateOrder,
                  onClick: () =>
                    navigate(`/medicine/createOrder/${props.item.prescCode}`),
                  icon: Copy,
                  ariaLabel: `${dictionary.duplicateOrder} ${props.item.prescCode}`,
                }
              : undefined
          }
          leftButtonRole='link'
          rightButtonRole='link'
        />
      </Grid>
      {props.item.adminIsrId && (
        <Stack
          alignItems={'center'}
          gap={'8px'}
          flexDirection={'row'}
          m='25px 0 15px'
        >
          <Avatar
            sx={{ width: '20px', height: '20px' }}
            alt={Dictionary[DICTIONARY.General].warning}
            src={PurpleOutlineWarningIcon}
          />
          <Typography variant='body3' role='note'>
            {Dictionary[DICTIONARY.Applies].openedByWing}
          </Typography>
        </Stack>
      )}
    </Grid>
  );
};
